var map = {
	"./Admin": [
		7202,
		7202
	],
	"./Admin.vue": [
		7202,
		7202
	],
	"./Test": [
		5656,
		5656
	],
	"./Test.vue": [
		5656,
		5656
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4985;
module.exports = webpackAsyncContext;